<template>
  <div class="stepper width-expand">
      <div class="steps-wrapper flex gap-xl flex-between width-expand">
        <div class="step"
             @click="attemptStepRequest(index)"
             :class="{'step--complete': stepIndex > index , 'step--enabled': step.isEnabled,'step--current': stepIndex === index}"

             v-for="(step,index) in steps" :key="`${stepprId}-step-stepIndex`">
          <div class="step__indicator flex-middle flex-center padding-s">
            <icon class="animate__fadeIn animate--fastest" v-show="stepIndex > index" icon="check" :size="1.5"></icon>
          </div>
          <div class="step__content" v-if="isNonEmptyString(step.label)">
            <span>{{t(step?.label)}}</span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    orientation: {
      type: String,
      default: 'horizontal',
    },
  //  [{label: false,done: false,enabled: false}]
    modelValue: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: () => ([])
    },
  },
  emits: ['stepper:request-step'],
  setup(props) {
  },
  data() {
    return {
      stepprId: utilities.getUniqueNumber() + '-stepper-'
    };
  },
  computed: {
    stepIndex: {
      set(val){
        console.log('emit model value', val);
        this.$emit("update:modelValue", parseInt(val));
      },
      get(){
        console.log("compute stepIndex", this.modelValue)
        return parseInt(this.modelValue);
      }
    },
    currentStep() {
      return this.steps?.[this.stepIndex];
    }
  },
  methods: {
    attemptStepRequest(index) {
      let step = this.steps[index];
      if ( ! step) {
        return false;
      }

      if ( ! step.isEnabled) {
        return false;
      }

      this.stepIndex = index;

      return true;
    }
  },
}
</script>
